export default function AboutUs() {
    return (
        <section id="AboutMe" className="about--section">
            <div className="about--section--img">
                <img src="./img/about_us.png" alt="About Me" />
            </div>
            <div className="company--section--content--box about--section--box">
                <div className="company--section--content">
                    <p className="section--title">Компания</p>
                    <h1 className="skills-section--heading">О нас</h1>
                    <p className="company--section-description">
                        Мы компания с архитектурным бэкграундом, способная охватить весь спектр задач по проекту, начиная от концепции и заканчивая дизайном сопутствующей продукции.
                        Наши навыки креативного и критического взгляда позволяют нам справляться с любой задачей и создавать прогрессивные проекты.
                    </p>
                    <p className="company--section-description">
                        Мы работаем в первую очередь на результат и всегда рады заказчикам со схожим мировозрением.
                    </p>
                </div>
            </div>
        </section>
    );
}